import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Modal, ModalHeader} from 'reactstrap';

export class MiniModal extends Component {
    render() {
        const props = this.props,
            options = props.options || {};

        return (
            <Modal
                isOpen={props.IsOpen}
                size={options.size || 'md'}
                fade={false}
                toggle={props.onClose}
                modalClassName="custom-mini-modal"
            >
                <ModalHeader> {props.header} </ModalHeader>
                {props.children}
            </Modal>
        );
    }
}

MiniModal.propTypes = {
    IsOpen: PropTypes.bool,
    onClose: PropTypes.func,
    children: PropTypes.node,
};